module.exports = __webpack_public_path__ + "static/media/49.8f2aa52f.jpg";